import PropTypes from 'prop-types';

import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui';

import {VariationAttributesComplex} from '@amblique/king-living/app/components/product-view/variation-attributes-complex';
import {VariationAttributesSimple} from '@amblique/king-living/app/components/product-view/variation-attributes-simple';

/**
 * Variation Attributes
 * Renders variation attributes for a product.
 *
 * @param {object} props
 * @param {object} props.product
 * @param {boolean} props.isProductPartOfSet
 * @param {boolean} props.isProductPartOfBundle
 *
 * @returns {React.ReactNode}
 */
export const VariationAttributes = ({
  isSimpleProduct,
  isComplexProduct,
  product,
  showLoading,
  variationAttributes,
}) => {
  return showLoading ? (
    <>
      {/* First Attribute Skeleton */}
      <Skeleton height={6} width={32} />
      <Skeleton height={20} width={64} />

      {/* Second Attribute Skeleton */}
      <Skeleton height={6} width={32} />
      <Skeleton height={20} width={64} />
    </>
  ) : isSimpleProduct ? (
    <VariationAttributesSimple variationAttributes={variationAttributes} />
  ) : isComplexProduct ? (
    <VariationAttributesComplex product={product} variationAttributes={variationAttributes} />
  ) : null;
};

VariationAttributes.displayName = 'VariationAttributes';

VariationAttributes.propTypes = {
  isSimpleProduct: PropTypes.bool,
  isComplexProduct: PropTypes.bool,
  product: PropTypes.object,
  showLoading: PropTypes.bool,
  variationAttributes: PropTypes.array,
};
